import { parseDocumentFromString, serializeDocument } from 'anodum';
import fetchAsset from './fetch-asset';
import errors from '../../errors';
import base64Decode from '../../../utils/base64-decode';

const fetchPageHTML = (source, options) =>
  fetchAsset(source, options)
    .then((response) => {
      const pageData = options && options.encode ? base64Decode(response.data) : response.data;
      const pageDocument = parseDocumentFromString(pageData, false);
      return serializeDocument(pageDocument);
    })
    .catch((error) => {
      errors.operations.catchError(error);
    });

export default fetchPageHTML;
